import React, { Component } from 'react'

import 'rheostat/initialize'
import Rheostat from 'rheostat'

class RangeSlider extends Component {
  constructor (props) {
    super(props)

    this.state = {
      valMin: this.props.rangeState.from,
      valMax: this.props.rangeState.to,
      singleValue: [this.props.rangeState.single]
    }

    this.handleSlide = this.handleSlide.bind(this)
  }

  handleSlide (e) {
    this.setState({ singleValue: [parseInt(e.values)] })
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ singleValue: [parseInt(nextProps.rangeState.single)] })
  }

  render () {
    let currentAge = (this.state.singleValue[0] === this.props.rangeState.from) ? '' : (this.state.singleValue[0] === this.props.rangeState.to) ? this.props.rangeState.to + '+' : this.state.singleValue

    return (
      <div className='age-slider'>
        <div className='slider-label'>
          {this.props.label} {currentAge}
        </div>
        <Rheostat
          min={this.props.rangeState.from}
          max={this.props.rangeState.to}
          values={this.state.singleValue}
          onValuesUpdated={this.handleSlide}
          onChange={this.props.rangeChange}
        />
        <div className='indicator-labels'>
          <div className='val-min'>{this.props.rangeState.from}</div>
          <div className='val-max'>{this.props.rangeState.to}</div>
        </div>
      </div>
    )
  }
}

export default RangeSlider
